import { config } from "../config";

export const calculateMarkup = (baseAmount, isHotel = false) => {
  const amount = parseFloat(baseAmount);
  const { markupType, markupValue } = isHotel
    ? config.hotelPricing
    : config.pricing;

  if (markupType === "flat") {
    return markupValue;
  }

  // percentage
  return amount * (markupValue / 100);
};

export const calculateFinalPrice = (baseAmount, isHotel = false) => {
  const amount = parseFloat(baseAmount);
  return amount + calculateMarkup(amount, isHotel);
};

export const formatPrice = (amount, currency) => {
  return amount.toLocaleString(undefined, {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
